module.exports = __webpack_public_path__ + "img/wdgc.b3528721.png";